import React from "react";
import shortid from "shortid";

export default function useFieldId(defaultId = null) {

    let id = defaultId || ['_', shortid.generate()].join('_');

    const [stateId, setStateId] = React.useState(id);

    return stateId;
}
